import React, { useState } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import moment from 'moment'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect,
  Modal, DatePicker,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton,
} from 'konsys-ui'
import axios from 'axios'
import fileDownload from 'js-file-download'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText } from '../../pages/gas-page/constants'
import { P } from '../../pages/gas-page/styled'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value}/>
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.OLD, text: statusText.OLD },
    { value: status.NEWS, text: statusText.NEWS },
    { value: status.LICENSE_EXPIRED, text: statusText.LICENSE_EXPIRED },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ปกติ"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_GAS_STATION)}>
        <Link target="_blank" to={`/gas-station/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_GAS_STATION)}>
        <Link target="_blank" to={`/gas-station/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const DownloadFuelorderExcelModal = ({
  modal,
  setModal,
  gasStation,
}) => {
  const [range, setRange] = useState([])
  const [loading, setIsLoading] = useState(false)
  const [statusType, setStatusType] = useState('1')
  const limitList = [
    { value: '1', text: 'รอลงบิล' },
    { value: '2', text: 'ได้รับบิลแล้ว' },
  ]

  const {
    gasstationId,
    info,
  } = gasStation
  return (
      <Modal
        title='กรุณาเลือกวันเริ่มต้นและวันสิ้นสุด'
        visible={modal}
        destroyOnClose={true}
        onCancel={() => {
          setModal(false)
          setStatusType('1')
          setRange([])
          setIsLoading(false)
        }}
        onOk={() => {
          setIsLoading(true)
          axios({
            method: 'GET',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${getAccessToken()}`,
            },
            url: `${getURL().FILE_SERVER}/download/excel/fuelOrderByGasstation?${
              [
                `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
                `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
                `gasstationId=${gasstationId}`,
                `statusType=${statusType}`,
              ].join('&')
            }`,
          }).then((resp) => {
            fileDownload(resp.data, `รายงานใบเบิกน้ำมัน ${(info && info.name) || ''} ที่${_.find(limitList, e => e.value === statusType).text} ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} .xlsx`)
            setIsLoading(false)
            setModal(false)
            setStatusType('1')
            setRange([])
          })
        }}
        okButtonProps={{ disabled: _.isEmpty(range) || loading }}
      >
        <Div textAlign='center'>
          <Select
            autoClearSearchValue
            dropdown
            style={{ width: 150, margin: '0 0 24px 0' }}
            defaultValue="รอลงบิล"
            onSelect={(e) => {
              setStatusType(e)
            }}
          >
            {
              limitList.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            onChange={(e) => {
              setRange(e)
            }}
          />
        </Div>
      </Modal>
  )
}
export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, gasstation,
}) => {
  const [modal, setModal] = useState(false)
  return (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    {isViewMode && <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_GAS_STATION)) || disabled}
      text='พิมพ์รายงานใบเบิกน้ำมัน'
      inverse
      onClick={() => setModal(true)}
      margin='0px 5px 0px 0px'
    />}
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_GAS_STATION)) || disabled}
      text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/gas-station/edit/${props.match.params.id}`)
        else {
          doAction({
            variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
          }).then(({ data }) => {
            const resp = isAddMode ? data.CreateGasstation : data.UpdateGasstation

            if (resp.success) {
              message.success(resp.message)
              if (isAddMode) history.push('/gas-station')
              // else {
              //   refetch()
              //   history.push(`/gas-station/view/${props.match.params.id}`)
              // }
            } else message.error(resp.message)
          })
        }
      }}
    />

    { !_.isEmpty(gasstation) && <DownloadFuelorderExcelModal
      loading={loading}
      modal={modal}
      setModal={setModal}
      props={props}
      gasStation={{
        gasstationId: props.match.params.id,
        info: gasstation,
      }}
    >
    </DownloadFuelorderExcelModal>
    }
  </Div>
  )
}
